"use client";

import { Link } from "@/i18n/Link";
import type { ProductCard } from "@/lib/centra";
import { useAtomValue } from "jotai";
import Image from "next/image";
import { variantAtom } from "./Variants";
import styles from "../ProductCard.module.css";

type Props = {
	media: ProductCard["media"];
	href: string;
	priority?: boolean;
	sizes?: string;
	children?: React.ReactNode;
	variantMedia: Record<string, ProductCard["media"]>;
	product: ProductCard;
	tagLabels?: string[];
};

export const ProductCardMedia = ({
	media,
	href,
	priority,
	sizes,
	children,
	variantMedia,
	product,
	tagLabels,
	...rest
}: Props) => {
	const variant = useAtomValue(variantAtom);

	const currentMedia = (variant ? variantMedia[variant] : media) || media;

	const firstImage = currentMedia[0];
	const secondImage = currentMedia[1];

	if (!firstImage) return null;

	return (
		<Link
			href={href}
			{...rest}
			tabIndex={-1}
			// aria-label={`${product.name} ${product.variantName}, ${tagLabels ? ` ${tagLabels.join(", ")}` : ""}`}
		>
			<figure className={styles.image}>
				{firstImage && (
					<Image
						priority={priority}
						fetchPriority={priority ? "high" : "auto"}
						sizes={sizes}
						src={firstImage.href}
						alt={firstImage.alt}
						fill
					/>
				)}

				{secondImage && (
					<Image
						src={secondImage.href}
						alt={secondImage.alt || ""}
						fill
						sizes={sizes}
						className={styles.second}
						fetchPriority="low"
					/>
				)}

				{children}
			</figure>
		</Link>
	);
};
